<template class="data-list">
  
    <div class="text-color background-color model-item">
      <div class="title">
        
        <div class="model-desc" style="display: flex;">
          <img :src="carModelItem.CarImageUrl" loading="lazy" />
          <div class="model-detail">
            <h5>{{ carModelItem.Title | persian }}</h5>
            <h5 v-if="carModelItem.MaxPrice">
              {{ carModelItem.MaxPrice | separator | persian }} تومان
            </h5>
          </div>
          <h5 v-if="!carModelItem.MaxPrice">-</h5>
          <div v-if="carModelItem.Percent != 0" class="detail">
            <div class="sub-title">{{ carModelItem.SubTitle | persian }}</div>
            <div
              class="percent"
              :class="[
                carModelItem.Percent > 0 ? 'danger' : '',
                carModelItem.Percent < 0 ? 'success' : '',
              ]"
            >
              <i class="fas fa-square" v-if="carModelItem.Percent == 0"></i>
              <i class="fas fa-caret-down" v-if="carModelItem.Percent < 0"></i>
              <i class="fas fa-caret-up" v-if="carModelItem.Percent > 0"></i>
              % {{ carModelItem.Percent }}
            </div>
          </div>
        </div>
        <!-- <div class="item-desc">
          <p style="font-size: 0.6rem;">
            <i class="fa fa-clock"></i>
            17 دقیقه پیش
          </p>
          <i class="fa fa-chart-bar" style="color: #2b4bca; text-align:left;"></i>
        </div> -->
      </div>
    </div>
  
</template>

<script>
export default {
  name: "car-price-model-item",
  props: {
    carModelItem: { required: true },
  },
};
</script>

<style scoped>
.model-item {
  text-align: right;
  padding: 0;
  margin: 5px 0 20px;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  position: relative;
  text-align: center;
}
.data-list>div:last-child {
  border-bottom: none;
}
.model-item > div {
  padding: 5px;
  text-align: right;
}
.model-item .title {
  display: flex;
  flex: 1;
  padding: 10px;
  justify-content: space-between;
}
.model-item img {
  width: 90px;
}
.item-desc {
  display: flex;
  justify-content: space-between;
  flex-direction: column;
}
.item-desc i.fa-clock{
  color: #999;
  font-size: 8px;
}
.model-item .detail {
  display: flex;
  align-items: flex-end;
}
.model-item .detail .sub-title {
  flex: 1;
}
.model-item .percent {
  font-weight: bold;
  font-size: 1.2em;
  direction: ltr;
}
.model-item .danger {
  color: red;
}
.model-item .success {
  color: #75d714;
}
.model-item .fas.fa-square {
  font-size: 9px;
  color: #aaa;
}
.model-detail{
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding-right: 5px;
}
</style>
